import {
  ADD_APPLICANT,
  GET_APPLICATION,
  REVIEW_APPLICATION,
  UPDATE_STATUS,
  UPDATE_INSPECTION_STATUS,
  ACTIVATE_ACCOUNT,
  REVIEWED_APPLICATION,
} from "../constants/action-types";

const initilState = {
  state: "",
};

const applicationReducer = (state = initilState, action) => {
  switch (action.type) {
    case ADD_APPLICANT:
      return {
        ...state,
        ...state.data.push(action?.payload),
      };
    case GET_APPLICATION:
      return {
        ...state,
        data: action.payload,
      };
    case REVIEW_APPLICATION:
      const index = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(index, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    case UPDATE_INSPECTION_STATUS:
      const dispatchCard = state.data.filter(
        (ele) => ele.id !== action?.payload.id
      );
      // state.data.splice(activateAccount, 1, action?.payload);
      return {
        ...state,
        data: dispatchCard,
      };
    case UPDATE_STATUS:
      const updateStatus = state.data.findIndex(
        (ele) => ele.id == action?.payload.id
      );
      state.data.splice(updateStatus, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    case REVIEWED_APPLICATION:
      const reviewIndex = state.data.filter(
        (ele) => ele.id !== action?.payload.id
      );
      return {
        ...state,
        data: reviewIndex,
      };
    case ACTIVATE_ACCOUNT:
      const activateAccount = state.data.findIndex(
        (ele) => ele.id == action?.payload.id
      );
      state.data.splice(activateAccount, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };

    default:
      return state;
  }
};

export default applicationReducer;
